import React from "react";
import { SocialMediaPlatformCode } from "shared-types";
import { FEATURE_FLAGS, useLaunchDarklyFlags } from "shared-services";
import { useTranslation } from "i18n";
import { useGetSocialMedia } from "pages/Profile/components/SocialMediaSection/hooks/useGetSocialMedia";
import { useGetProfileSocialMediaWebsite } from "pages/Profile/hooks/useGetProfileSocialMediaWebsite";

const SocialMediaPrint = () => {
  const { t } = useTranslation();
  const isInstagramIntegrationEnabled = useLaunchDarklyFlags(
    FEATURE_FLAGS.InstagramIntegration
  );
  const { data = {} } = useGetSocialMedia(isInstagramIntegrationEnabled);
  const { socialMedia } = useGetProfileSocialMediaWebsite();

  const instagramData = data[SocialMediaPlatformCode.Instagram];

  return (
    <>
      {socialMedia?.website && (
        <p className="leading-tight">
          <strong>
            {t("performer:profile.socialMedia.PerformerWebsite.label")}:
          </strong>{" "}
          {socialMedia.website}
        </p>
      )}

      {instagramData?.profileUrl && (
        <p className="leading-tight">
          <strong>{t("performer:profile.socialMedia.instagram.label")}:</strong>{" "}
          {instagramData.profileUrl}
        </p>
      )}
    </>
  );
};

export default SocialMediaPrint;
